import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid2, ListItemText, ListItemButton } from '@mui/material';
import { useStyles } from './styles';
import { useExperiences } from 'core/contexts/experience';
import { useAuth } from 'core/contexts/auth';
import { CircularIndeterminate } from '@utriper/core-ui';
import { ExperienceStatus } from '@utriper/core';
import ExperienceStatusChip from 'components/ExperienceStatusChip';

const ExperiencesList = ({ showActive }) => {
    const classes = useStyles();
    const history = useHistory();
    const { getUserInfoSync } = useAuth();
    const { experiences, loading, getExperiencesUpdated } = useExperiences();

    useEffect(() => {
        async function fetchData() {
            return await getUserInfoSync();
        }
        fetchData().then((usr) => getExperiencesUpdated(usr?.experiencer?.id));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const filteredExperiences = experiences?.filter((experience) => {
        if (showActive) {
            return experience.status !== ExperienceStatus.IDS.archived; // Muestra experiencias activas
        } else {
            return experience.status === ExperienceStatus.IDS.archived; // Muestra experiencias archivadas
        }
    });

    filteredExperiences?.sort((a, b) => b.status - a.status);

    return loading ? (
        <CircularIndeterminate centered={true} />
    ) : (
        filteredExperiences?.map((experience) => (
            <Grid2 key={experience?.id} size={{ xs: 12, sm: 6, md: 4 }}>
                <ListItemButton className={classes.listItem} onClick={() => history.push(`/experience/${experience?.id}`)}>
                    <ListItemText primary={experience?.name} sx={{ padding: '8px' }} />
                    <ExperienceStatusChip status={experience?.status} />
                </ListItemButton>
            </Grid2>
        ))
    );
};

ExperiencesList.displayName = 'ExperiencesList';

export default ExperiencesList;
